import {
  Card,
  Text,
  Box,
  Group,
  Accordion,
  Blockquote,
  List,
  ListItem,
  Anchor,
} from '@mantine/core';
import React from 'react';
import TagList from './TagList';
import { theme } from '../consilitheme';
import { IconLink, IconInfoCircle } from '@tabler/icons-react';

function DiscoveryItem({
  discovery,
  relatedInterest,
  activeTopics,
  setActiveTopics,
  removeTag,
  title,
}) {
  const {
    highlight,
    created,
    categories,
    source,
    rationale,
    link,
    linktitle = [],
  } = discovery;

  const datePattern = /\/(\d{4}-\d{2}-\d{2})\//;
  const match = link.match(datePattern);

  const dateString = match ? match[1] : created;
  const dateObject = new Date(dateString);
  const formattedDate = [
    dateObject.toISOString().split('T')[0],
    dateObject.toLocaleTimeString('en-US', { hour12: true }),
  ];

  // support legacy analysis objects using old prompt
  const discoveryBody = rationale.startsWith('Yes, ')
    ? rationale.charAt(5).toUpperCase() + rationale.substring(6).trim()
    : rationale;

  const env = process.env.NODE_ENV;
  const chatUrl =
    env === 'development'
      ? `http://chat-local.consili.io:3000/?i=${discovery.id}`
      : `https://chat.consili.io?i=${discovery.id}`;

  return (
    <Card shadow="md" radius="md" withBorder>
      <Accordion.Control
        style={{
          backgroundColor: 'transparent',
          outlineColor: 'transparent',
          width: '102%',
        }}
      >
        <Group justify="space-between">
          <Text
            size="md"
            fw={600}
            style={{ marginBottom: '0.5rem', width: '80%' }}
          >
            {title?.length ? title : highlight}
          </Text>
          <Text
            size="sm"
            c={theme.colors.gray[3]}
            mr={'8px'}
            pos="absolute"
            right={28}
            top={28}
          >
            {formattedDate[0]}
          </Text>{' '}
          <Text
            size="sm"
            c={theme.colors.gray[3]}
            mr={'8px'}
            pos="absolute"
            right={28}
            top={44}
          >
            {formattedDate[1]}
          </Text>{' '}
        </Group>
      </Accordion.Control>
      <Accordion.Panel>
        <Text fw={300} pl={0}>
          {discoveryBody}
        </Text>
        <Text
          fw={700}
          mt={16}
          fs={'italic'}
          variant="gradient"
          gradient={{ from: 'blue', to: 'cyan', deg: 90 }}
        >
          {'('}Want to learn more?{' '}
          <Anchor href={chatUrl} target="_blank" fs="normal" fw={500}>
            Chat with our assistant
          </Anchor>
          <IconLink color={'blue'} size={16} />
          {')'}
        </Text>

        <Blockquote color="blue" icon={<IconInfoCircle />} mt="xl" ml="sm">
          <Text fw={600}>Relevant research topics: </Text>
          <List>
            <ListItem>{relatedInterest}</ListItem>
          </List>
        </Blockquote>
      </Accordion.Panel>
      <Group mb={theme.padding.md} mt={theme.padding.sm} pl="md">
        {source && (
          <TagList
            baseTags={[source]?.map((source) => source?.name)}
            activeTopics={[source]?.map((source) => source?.name)}
            defaultOutline
            large
            tagColor={theme.colors.blue[3]}
            removeTag={removeTag}
          />
        )}
      </Group>
      <Group pl="md">
        {categories?.length && (
          <Box w={800}>
            <TagList
              defaultOutline
              baseTags={categories?.map((category) => category?.name)}
              activeTopics={activeTopics}
              setActiveTopics={setActiveTopics}
              clickable
              tagColor={theme.colors.purple[3]}
              removeTag={removeTag}
            />
          </Box>
        )}
        <Group ml="auto">
          <a href={link} target={'_blank'} rel="noreferrer">
            {link && (
              <Group justify="space-around" gap={4}>
                <IconLink color={'gray'} size={20} />
                <Text
                  size="sm"
                  c={theme.colors.gray[3]}
                  style={{ translateX: '10px' }}
                >
                  {linktitle
                    ? linktitle?.length <= 100
                      ? linktitle
                      : linktitle?.slice(0, 50) + '...'
                    : 'No Link Title'}
                </Text>
              </Group>
            )}
          </a>{' '}
        </Group>
      </Group>{' '}
    </Card>
  );
}

export default DiscoveryItem;
